import React, {ReactElement, useContext} from 'react';
import {cx} from '@emotion/css';

import {useIdentityContext} from '../../../RootProvider/IdentityContext';
import DeviceContext, {Device} from '../../../RootProvider/DeviceContext';
import styles from './CurrentUser.styles';

interface Props {
  hideName?: boolean;
  hideNameMobile?: boolean;
  className?: string;
}

function CurrentUser({className, hideName, hideNameMobile}: Props): ReactElement | null {
  const device = useContext(DeviceContext);
  const {user} = useIdentityContext();

  if (!user) {
    return null;
  }

  const names = [user.first_name, user.last_name].filter((nameValue) => {
    if (!nameValue) {
      return false;
    }
    if (nameValue.trim() === '') {
      return false;
    }
    return true;
  });

  const userName = names.length ? names.join(' ') : user.email;
  const firstInitial = userName[0];
  const showName = !hideName && !(hideNameMobile && device === Device.MOBILE);

  return (
    <div className={cx(styles.container, className)}>
      <span className={cx(styles.initial)}>{firstInitial}</span>
      {showName && <span data-testid="ui.currentUser.name">{userName}</span>}
    </div>
  );
}

export default CurrentUser;
